import { render, staticRenderFns } from "./USPMarquee.vue?vue&type=template&id=7cb31065&"
import script from "./USPMarquee.vue?vue&type=script&lang=js&"
export * from "./USPMarquee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports